

















import useTimeout from "@/shared/composition/useTimeout";
import useContenido from "./useContenido";
import Vue from "vue";

import {
  computed,
  defineComponent,
  ref,
  toRefs,
  watch,
} from "@vue/composition-api";

export default defineComponent({
  props: {
    atributos: Object,
    value: null,
    requerido: Boolean,
    get: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, { emit }) {
    const { get } = toRefs(props);

    const { items: itemsData, cargar, cargando } = useContenido(get);

    const input = ref();
    const search = ref();

    const items = computed(() => [
      ...itemsData.value,
    ]);

    const reglas = computed(() => {
      return [(v) => !props.requerido || !!v || "Requerido"];
    });

    const actualizar = (valor) => {
      emit("input", valor);
    };

    const { reset } = useTimeout(500);

    watch(search, (busqueda) => {
      // console.warn("search actualizado:", { busqueda })

      if(typeof(busqueda) == "string" && busqueda.length <= 3){
        return
      }

      reset(() => cargar({ busqueda }));
    });

    watch(get, () =>
      console.warn(
        "***recagar cuando cambie get por implementar en autocomplete y lista"
      )
    );

    const desenfocar = () => {
      console.log("desenfocando");
      input.value.blur();
    };

    const ocultarMenu = () => {
      Vue.nextTick(() => desenfocar())
    }

    return {
      items,
      emit,
      actualizar,
      desenfocar, // Para que parent pueda desenfocar
      input,
      reglas,
      search,
      cargando,
      ocultarMenu
    };
  },
});
